import { postTrackingData } from "@/api/endpoints/track";
import InfoLink from "@/containers/InfoLink";
import { EVENT } from "@/tracking_events";
import Doughnut from "@components/Charts/Doughnut";
import ClickHandlerPlugin from "@components/Charts/plugins/ClickHandlerPlugin";
import DoughnutCenterTextPlugin from "@components/Charts/plugins/DoughnutCenterTextPlugin";

import { BaseWidget } from "../BaseWidget";
import { toPieData } from "./utils";
import { WidgetProps } from "./WidgetProps";

import styles from "./InsightWidgets.module.css";

type SentimentShareData = {
  results: {
    labels: string[];
    net_sentiment: number;
    dataset: { label: string; data: number[] }[];
  };
}[];

export const NetSentimentInfoLink = () => (
  <InfoLink
    content={L.MENTIONS_NET_SENTIMENT_INFO}
    href={L.HELP_ARTICLE_NET_SENTIMENT}
  />
);

const SentimentShare: React.FunctionComponent<
  WidgetProps<SentimentShareData>
> = (props) => {
  const { data } = props;
  const chartData = data?.length && toPieData(data?.[0]?.results.dataset);

  const hasData = data?.some(({ results }) =>
    results?.dataset?.some(({ data }) => data?.some((d: number) => d > 0))
  );

  return (
    <BaseWidget
      extraHeader={<NetSentimentInfoLink />}
      containerClassName={styles.pie}
      hasData={hasData}
      {...props}
      title={L.REPORTS_WIDGET_DEFAULT_TITLE_SENTIMENT_SHARE_INSIGHTS}
    >
      {chartData && (
        <Doughnut
          data={chartData}
          options={{
            plugins: {
              doughnutCenterText: {
                texts: [
                  [
                    `${data[0].results.net_sentiment > 0 ? "+" : ""}${
                      data[0].results.net_sentiment
                    }%`,
                    0.3,
                  ],
                  [
                    L.REPORTS_WIDGET_DEFAULT_TITLE_SENTIMENT_SHARE_INSIGHTS_CENTER_LABEL,
                    0.1,
                  ],
                ],
              },
              click: {
                onClick: (appliedFilters) => {
                  postTrackingData(EVENT.WIDGET_CLICK, {
                    widget: props.metric,
                  });
                  props.fetchMentions_v2(appliedFilters);
                },
              },
              tooltip: {
                callbacks: {
                  label: () => {
                    return "";
                  },
                },
              },
            },
          }}
          plugins={[ClickHandlerPlugin, DoughnutCenterTextPlugin]}
        />
      )}
    </BaseWidget>
  );
};

export default SentimentShare;
